import React from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../ThemeModule";
const BlogArticle = ({node}) => {
  return (
    <>
      <article key={node.slug} className="post_itemBox">
        <div className="post_innerBox">
          <Link to={`/blog/${node.slug}`} data-cursor-text="View More" data-cursor-size="100px" className="post_img">
            <img
              src={node.featureImage.url}
              alt={node.title}
              className="post-img"
            />
          </Link>

          <div className="post_content ">
            <div className="post-category">
              {node.categories.map((category) => (
                <span key={category.title} className="">
                  {category.title}
                </span>
              ))}
            </div>
            <h3 className="post-title" >
              <Link to={`/blog/${node.slug}`}>{node.title}</Link>
            </h3>
            <p className="post-date">{formatDate(node.publishedAt)}</p>
          </div>
        </div>
      </article>
    </>
  );
};

export default BlogArticle;
